/**
 * Document Material Component
 *
 * Displays text documents with download option.
 */

import { useTranslation } from 'react-i18next';
import { useMaterialUrl, type Material } from '@immopersian/common';
import { LoadingSpinner } from './shared/LoadingSpinner';
import { ErrorMessage } from './shared/ErrorMessage';
import { MaterialDescription } from './shared/MaterialDescription';
import { FileCard } from './shared/FileCard';
import { TextDocIcon } from './shared/Icons';

interface DocMaterialProps {
  material: Material;
}

export function DocMaterial({ material }: DocMaterialProps) {
  const { t } = useTranslation();
  const { data, isLoading, error } = useMaterialUrl(material.id, material.type);

  if (isLoading) {
    return <LoadingSpinner message={t('courses.loadingDocument')} />;
  }

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  return (
    <>
      <MaterialDescription material={material} />
      <FileCard
        url={data?.url || ''}
        icon={<TextDocIcon />}
        label={t('courses.document')}
        openLabel={t('courses.open')}
      />
    </>
  );
}
